import React from 'react';
import Lottie from 'lottie-react';
import { Box } from '@mui/material';
import loginAnimation from '../../../../asserts/NESiCZhDEe.json'; // place JSON inside src/assets

export default function LottieAnimation() {
	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'center' }}>
				<Lottie
					animationData={loginAnimation}
					loop={true}
					style={{ width: '80%', height: 'calc(100vh - 40px)' }}
				/>
			</Box>
		</>
	);
}
